import styled from 'styled-components';

export const CardActionButtonsWrapper = styled.div`
  display: flex;
  gap: 24px;
  padding: 16px 0px;
`;
